import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function Services() {
  const priceCategories = [
    {
      title: "Konsultation & Attester",
      items: [
        { name: 'Konsultation privat', price: 'fra kr. 500,-' },
        { name: 'Konsultation – gruppe 2', price: 'kr. 600,-' },
        { name: 'Kørekortattest', price: 'kr. 650,-' },
        { name: 'Attest til arbejdsgiver (refusion)', price: 'fra kr. 850,-' },
        { name: 'Attest privatperson', price: 'fra kr. 600,-' },
        { name: 'Attest ved sygdom for studerende', price: 'kr. 350,-' },
        { name: 'Handicap parkering/ledsager', price: 'kr. 650,-' },
        { name: 'Forsikringsattester (+ 25% moms)', price: 'variabel' },
      ]
    },
    {
      title: "Vaccinationer",
      items: [
        { name: 'Influenza', price: 'Vaccinationscentre' },
        { name: 'Pneumokok – 23 valent', price: 'kr. 275,-' },
        { name: 'Difteri+Tetanus (stivkrampe)', price: 'kr. 250,-' },
        { name: 'Difteri+Tetanus+Kighoste', price: 'kr. 300,-' },
        { name: 'Vaccinationshonorar (v. recept)', price: 'kr. 150,-' },
      ]
    }
  ];

  return (
    <main className="pt-12 pb-24">
      <Helmet>
        <title>Ydelser & Priser | Hellerup Lægehus</title>
        <meta name="description" content="Se priser på ydelser, der ikke dækkes af sygesikringen, herunder kørekortattest, rejsevaccinationer og forsikringsattester hos Hellerup Lægehus." />
        <meta property="og:title" content="Ydelser & Priser | Hellerup Lægehus" />
        <meta property="og:description" content="Se priser på ydelser, der ikke dækkes af sygesikringen, herunder kørekortattest, rejsevaccinationer og forsikringsattester hos Hellerup Lægehus." />
        <html lang="da-DK" />
      </Helmet>
      <div className="max-w-7xl mx-auto px-6">
        <div className="bg-slate-50 text-slate-900 p-10 md:p-20 relative overflow-hidden">
          <div className="relative z-10">
            <div className="mb-16">
              <h2 className="text-4xl font-sans font-medium text-black mb-6 leading-tight tracking-tight">Prisliste</h2>
              <p className="text-slate-600 max-w-2xl leading-relaxed">
                Herunder finder du priser på ydelser, der ikke er dækket af sygesikringen (for gruppe 1). 
                Vi modtager betaling via betalingskort i klinikken.
              </p>
              <p className="text-sm text-amber-800 bg-amber-50 border-l-4 border-amber-500 p-3 mt-4 max-w-2xl rounded-r-md">
                <i className="fa-solid fa-circle-exclamation mr-2"></i>
                <strong>Bemærkning om udeblivelse:</strong> Ved udeblivelse uden afbud opkræves et udeblivelsesgebyr på 250-1.000 kr. afhængig af den afsatte tid.
              </p>
            </div>
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-32">
              {priceCategories.map((category) => (
                <div key={category.title}>
                  <h3 className="text-[#4b717a] text-xs tracking-widest uppercase font-bold mb-8 border-b border-slate-200 pb-4">
                    {category.title}
                  </h3>
                  <div className="flex flex-col">
                    {category.items.map((item) => (
                      <div 
                        key={item.name} 
                        className="flex justify-between items-center py-4 border-b border-slate-200 last:border-0"
                      >
                        <span className="text-sm text-slate-700 pr-4">{item.name}</span>
                        <span className="text-sm font-mono text-[#4b717a] font-bold whitespace-nowrap">{item.price}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          {/* Decorative element */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-[#4b717a]/5 blur-[120px] -translate-y-1/2 translate-x-1/2" />
        </div>
      </div>
    </main>

  );
}
